"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLocationSlug = createLocationSlug;
exports.createServiceCategorySlug = createServiceCategorySlug;
exports.createServiceItemSlug = createServiceItemSlug;
exports.createTeamMemberSlug = createTeamMemberSlug;
var _constants = require("./constants");
var _utils = require("./utils");
function createTeamMemberSlug(teamMember, teamMembers) {
  var rootSlug = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.DEFAULT_ROOT_SLUGS[_constants.TEAM_MEMBER_TYPE];
  var teamMemberSlug = (0, _utils.createPageSlug)(_constants.LOCATION_TYPE, teamMember, teamMembers);
  return (0, _utils.createFullPageSlug)(rootSlug, teamMemberSlug);
}
function createLocationSlug(location, locations) {
  var rootSlug = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.DEFAULT_ROOT_SLUGS[_constants.LOCATION_TYPE];
  var locationSlug = (0, _utils.createPageSlug)(_constants.LOCATION_TYPE, location, locations);
  return (0, _utils.createFullPageSlug)(rootSlug, locationSlug);
}
function createServiceCategorySlug(category, categories) {
  var rootSlug = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.DEFAULT_ROOT_SLUGS[_constants.SERVICE_CATEGORY_TYPE];
  var categorySlug = (0, _utils.createPageSlug)(_constants.SERVICE_CATEGORY_TYPE, category, categories);
  return (0, _utils.createFullPageSlug)(rootSlug, categorySlug);
}
function createServiceItemSlug(item, items, categories) {
  var rootSlug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.DEFAULT_ROOT_SLUGS[_constants.SERVICE_ITEM_TYPE];
  var context = {
    fullQuery: {
      allFishermanBusinessMenuCategory: {
        nodes: categories
      }
    }
  };
  var itemSlug = (0, _utils.createPageSlug)(_constants.SERVICE_ITEM_TYPE, item, items, context);
  return (0, _utils.createFullPageSlug)(rootSlug, itemSlug);
}